// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__jCh7f","inputWrap":"styles_inputWrap__Zwv0l","input":"styles_input__1C_F1"};